import { sagaCreator } from '@adrias-online/steiner';

import helper from 'helpers/steinerHelper';
import { actions, actionTypes } from '../actions/permessi';
import { selectors, DEFAULT_STATE } from '../reducers/permessi';
import api from '../apis/permessi';

const sagas = helper.createSagas(
    'permessi',
    actionTypes,
    actions,
    api,
    selectors,
    DEFAULT_STATE
);

const defaultSagas = sagaCreator.bootSagas(sagas, actionTypes);

export default [...defaultSagas];
